<template>
    <div class="menu">
        <div @click="goPath()" class="top">行业应用</div>
        <ul>
            <li @click="goPath(index, item)" :class="mebuActive == index ? 'active' : ''" v-for="(item, index) in list"
                :key="index">
                {{ item.name }}
            </li>
        </ul>
    </div>
</template>
<script>
import { applyDomainList } from '../../../api/index'
export default {
    data() {
        return {
            list: [],
            active: null,
        }
    },
    props: {
        mebuActive: ''
    },
    methods: {
        goPath(index, item) {
            const path = this.$route.path
            if (item) {
                this.$parent.active = index
                this.$emit('changeBreadcrumb', item)
                if (path != '/apply') {
                this.$router.push({
                    path: "/apply", query: {
                        applyDomainId: item.applyDomainId
                    }
                })
            }
            } else {
                this.$parent.active = -1
                this.$emit('changeBreadcrumb', {name:"",id:""})
                if (path != '/apply') {
                this.$router.push({
                    path: "/apply"
                })
            }
            }

        }
    },
    mounted() {
        // this.active = this.$route.query.id

        applyDomainList().then(res => {
            this.list = res.rows
        })
        if (this.active) {
            this.$emit('changeBreadcrumb', this.list[this.active].name)
        }
    }
}

</script>
<style lang="scss" scoped>
.top {
    background: url('../../../assets/img13.png') #1f3b6d;
    height: 90px;
    line-height: 90px;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    color: #fff;
    cursor: pointer;
}

.active {
    background-color: #476da7;
    color: #d1d1d1;
}

.menu {
    width: 250px;
}

ul {
    li {
        width: 250px;
        line-height: 86px;
        border-bottom: 1px solid #cfcfcf;
        background-color: #fff;
        text-align: center;
        font-size: 18px;
        cursor: pointer;
    }

    li:last-child {
        border: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/apply/compontents/menu.vue